import submitCommand from '../../../services/submitCommand';
import { Step } from '../models/course';
import { pollFeedbackStatus } from '../utils/pollFeedbackStatus';

const isStepComplete = (status: string): boolean => {
  return status === 'complete';
};

export const completeFeedbackStep = (
  id: string,
  task: Step,
  email: string,
  responseId: string,
  initiatingUserId: string,
  pollForUpdate: boolean = false
) => {
  const cmd = {
    id: id,
    initiatingUserId: initiatingUserId,
    taskInstance: task,
    email: email,
    responseId: responseId,
  };

  const commandPromise = submitCommand(
    id,
    cmd,
    'CompleteFeedbackTask',
    'TaskInstanceCompleted',
    'TaskListInstanceError'
  );

  if (!pollForUpdate) {
    return commandPromise;
  }

  return pollFeedbackStatus(id, responseId, isStepComplete, { interval: 1000, maxAttempts: 5, initialDelay: 1000 });
};
